import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { Request } from 'commons/utils/request'
import { AlertsReportPayload } from '~bank-reports/routes/AlertsReport/types'

export const alertsReportQueryOptions = (deps: Partial<AlertsReportPayload>) =>
  queryOptions({
    queryKey: ['alertsReportQueryOptions', deps],
    queryFn: () => Request.post(Request.urls.bank.portalReportAlerts, { ...deps }),
    structuralSharing: true,
    staleTime: 1000,
    placeholderData: keepPreviousData
  })
